import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowLeftIcon, SparklesIcon, TrophyIcon } from '@heroicons/react/24/outline';
import VotingPageShell from '../../components/voting/VotingPageShell';

const STYLES = `
  .vd-wrap { min-height:100vh; color:#f5f5f5; }
  .vd-wrap button:focus-visible, .vd-wrap a:focus-visible, .vd-wrap input:focus-visible { outline:2px solid #d81f2a; outline-offset:3px; }
  .vd-hero { position:relative; text-align:center; padding:52px 24px 48px; overflow:hidden; }
  .vd-hero-eyebrow { display:inline-flex; align-items:center; gap:8px; font-size:.72rem; font-weight:600; letter-spacing:.18em; text-transform:uppercase; color:#d81f2a; margin-bottom:16px; }
  .vd-hero-eyebrow span { width:28px; height:1px; background:#d81f2a; display:block; }
  .vd-hero h1 { font-size:clamp(2rem,4.5vw,3.25rem); font-weight:700; letter-spacing:-.02em; line-height:1.1; color:#f5f5f5; margin-bottom:14px; }
  .vd-hero p { font-size:.95rem; color:#9ca3af; max-width:520px; margin:0 auto; line-height:1.65; }
  .vd-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(min(100%,300px),1fr)); gap:16px; max-width:1280px; margin:0 auto; padding:0 24px 64px; }
  .vd-card { position:relative; background:#161618; border:1px solid #26262a; border-radius:12px; overflow:hidden; transition:border-color .2s ease,background .2s ease,transform .2s ease; display:flex; flex-direction:column; align-items:center; padding:32px 24px 24px; }
  .vd-card:hover,.vd-card:focus-within { border-color:#d81f2a; background:#1c1c1f; }
  .vd-rank { position:absolute; top:14px; left:16px; font-size:.8rem; font-weight:600; letter-spacing:.08em; color:#6b7280; user-select:none; }
  .vd-rank-1 { color:#d81f2a; }
  .vd-avatar-wrap { position:relative; width:104px; height:104px; border-radius:50%; margin-bottom:20px; flex-shrink:0; }
  .vd-avatar-ring { position:absolute; inset:-3px; border-radius:50%; border:2px solid #26262a; transition:border-color .2s ease; }
  .vd-card:hover .vd-avatar-ring,.vd-card:focus-within .vd-avatar-ring { border-color:#d81f2a; }
  .vd-avatar { width:100%; height:100%; border-radius:50%; object-fit:cover; background:#26262a; display:flex; align-items:center; justify-content:center; overflow:hidden; }
  .vd-avatar-init { font-size:2.2rem; font-weight:700; color:#d81f2a; }
  .vd-name { font-size:1.15rem; font-weight:700; letter-spacing:-.01em; margin-bottom:4px; text-align:center; }
  .vd-meta { font-size:.78rem; color:#9ca3af; display:flex; align-items:center; gap:6px; margin-bottom:22px; }
  .vd-meta svg { flex-shrink:0; }
  .vd-song { width:100%; background:#0a0a0b; border:1px solid #26262a; border-radius:10px; padding:12px 14px; display:flex; align-items:center; gap:12px; margin-bottom:24px; transition:border-color .2s; }
  .vd-card:hover .vd-song { border-color:#323236; }
  .vd-song-info { flex:1; min-width:0; }
  .vd-song-title { font-size:.88rem; font-weight:500; color:#f5f5f5; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .vd-song-sub { font-size:.72rem; color:#9ca3af; margin-top:2px; }
  .vd-play-btn { width:36px; height:36px; flex-shrink:0; border-radius:50%; background:#d81f2a; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:background .15s; color:#fff; }
  .vd-play-btn:hover { background:#b81b24; }
  .vd-no-song { width:100%; margin-bottom:24px; border:1px dashed #323236; border-radius:10px; padding:13px; text-align:center; font-size:.78rem; color:#6b7280; }
  .vd-vote-row { width:100%; display:flex; align-items:center; gap:14px; }
  .vd-count { display:flex; flex-direction:column; align-items:center; flex-shrink:0; min-width:56px; }
  .vd-count-num { font-size:1.9rem; font-weight:700; line-height:1; color:#f5f5f5; font-variant-numeric:tabular-nums; }
  .vd-count-label { font-size:.64rem; letter-spacing:.1em; text-transform:uppercase; color:#6b7280; margin-top:3px; }
  .vd-divider { width:1px; height:38px; background:#26262a; flex-shrink:0; }
  .vd-vote-btn { flex:1; min-height:42px; padding:11px 8px; border-radius:8px; border:none; cursor:pointer; font-family:inherit; font-size:.82rem; font-weight:600; letter-spacing:.02em; background:#d81f2a; color:#fff; transition:background .15s,transform .15s; display:flex; align-items:center; justify-content:center; gap:8px; }
  .vd-vote-btn:hover:not(:disabled) { background:#b81b24; }
  .vd-vote-btn:active:not(:disabled) { transform:scale(.98); }
  .vd-vote-btn:disabled { background:#26262a; color:#9ca3af; cursor:not-allowed; }
  .vd-vote-btn.success { background:#10b981 !important; }
  .spin { width:15px; height:15px; border:2px solid rgba(255,255,255,.3); border-top-color:#fff; border-radius:50%; animation:spin .6s linear infinite; }
  @keyframes spin { to { transform:rotate(360deg); } }
  .vd-loader { display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:60vh; gap:16px; }
  .vd-loader-ring { width:44px; height:44px; border:3px solid #26262a; border-top-color:#d81f2a; border-radius:50%; animation:spin .8s linear infinite; }
  .vd-loader p { font-size:.78rem; color:#9ca3af; letter-spacing:.1em; text-transform:uppercase; }
  .vd-empty { max-width:1280px; margin:0 auto 64px; padding:32px; border:1px solid #26262a; border-radius:12px; background:#101012; text-align:center; color:#9ca3af; }
  .vd-empty a { color:#fca5a5; }
  .vd-error { max-width:1280px; margin:0 auto 24px; padding:16px 20px; border:1px solid #7f1d1d; border-radius:10px; background:#251012; color:#fecaca; }
  .vd-error.mx-6 { margin-left:24px; margin-right:24px; }
  .vd-actions { max-width:1280px; margin:0 auto 24px; padding:0 24px; display:flex; align-items:center; justify-content:space-between; gap:16px; }
  .vd-actions a { color:#9ca3af; font-size:.875rem; text-decoration:none; display:inline-flex; align-items:center; gap:7px; }
  .vd-actions a:hover { color:#fff; }
  .vd-actions a:focus-visible,.vd-vote-btn:focus-visible,.vd-play-btn:focus-visible,.vd-player-close:focus-visible { outline:2px solid #d81f2a; outline-offset:3px; }
  .vd-rules { max-width:1280px; margin:0 auto 24px; padding:16px 20px; border:1px solid #26262a; border-radius:10px; background:#101012; color:#9ca3af; font-size:.85rem; line-height:1.6; }
  @media (max-width:640px) {
    .vd-hero { padding:40px 20px 44px; }
    .vd-grid { grid-template-columns:minmax(0,1fr); padding:0 16px 40px; }
    .vd-actions { margin:0 auto 20px; padding:0 16px; }
    .vd-rules,.vd-error,.vd-empty { margin-left:16px; margin-right:16px; }
    .vd-error.mx-6 { margin-left:16px; margin-right:16px; }
    .vd-card { padding:28px 20px 22px; }
  }
  @media (prefers-reduced-motion:reduce) {
    .vd-card,.vd-play-btn,.vd-vote-btn { transition:none; }
    .spin,.vd-loader-ring { animation-duration:1.8s; }
  }
  .vd-overlay { position:fixed; inset:0; z-index:999; display:flex; align-items:center; justify-content:center; padding:20px; background:rgba(0,0,0,.9); animation:fadeIn .2s ease; }
  @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
  .vd-player { background:#161618; border:1px solid #323236; border-radius:14px; width:100%; max-width:380px; padding:28px; position:relative; animation:slideUp .25s ease; }
  @keyframes slideUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
  .vd-player-close { position:absolute; top:18px; right:18px; width:30px; height:30px; border-radius:50%; background:#26262a; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; color:#9ca3af; transition:color .15s,background .15s; }
  .vd-player-close:hover { background:#323236; color:#f5f5f5; }
  .vd-cover-wrap { width:100%; aspect-ratio:1/1; border-radius:10px; overflow:hidden; background:#26262a; display:flex; align-items:center; justify-content:center; margin-bottom:22px; position:relative; }
  .vd-cover-wrap img { width:100%; height:100%; object-fit:cover; }
  .vd-cover-init { font-size:4rem; font-weight:700; color:#d81f2a; }
  .vd-player-info { text-align:center; margin-bottom:22px; }
  .vd-player-title { font-size:1.35rem; font-weight:700; letter-spacing:-.01em; margin-bottom:3px; }
  .vd-player-artist { font-size:.88rem; color:#fca5a5; margin-bottom:5px; }
  .vd-player-genre { font-size:.74rem; color:#9ca3af; }
  .vd-progress-wrap { margin-bottom:20px; }
  .vd-progress { -webkit-appearance:none; appearance:none; width:100%; height:3px; border-radius:99px; background:#26262a; cursor:pointer; outline:none; border:none; }
  .vd-progress::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; width:13px; height:13px; border-radius:50%; background:#d81f2a; cursor:pointer; transition:transform .15s; }
  .vd-progress:hover::-webkit-slider-thumb { transform:scale(1.25); }
  .vd-time-row { display:flex; justify-content:space-between; font-size:.72rem; color:#9ca3af; margin-top:6px; }
  .vd-controls { display:flex; align-items:center; justify-content:center; gap:20px; margin-bottom:18px; }
  .vd-pp-btn { width:52px; height:52px; border-radius:50%; background:#d81f2a; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; color:#fff; transition:background .15s; }
  .vd-pp-btn:hover { background:#b81b24; }
  .vd-vol-row { display:flex; align-items:center; justify-content:center; gap:10px; }
  .vd-vol-icon { color:#9ca3af; cursor:pointer; transition:color .15s; flex-shrink:0; }
  .vd-vol-icon:hover { color:#f5f5f5; }
  .vd-vol-slider { -webkit-appearance:none; appearance:none; width:80px; height:2px; border-radius:99px; background:#26262a; cursor:pointer; outline:none; border:none; }
  .vd-vol-slider::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; width:10px; height:10px; border-radius:50%; background:#9ca3af; cursor:pointer; }
  .vd-secure { text-align:center; font-size:.68rem; color:#6b7280; display:flex; align-items:center; justify-content:center; gap:5px; margin-top:18px; padding-top:14px; border-top:1px solid #26262a; }
`;

function injectStyles() {
  if (document.getElementById('vd-styles')) return;
  const style = document.createElement('style');
  style.id = 'vd-styles';
  style.textContent = STYLES;
  document.head.appendChild(style);
}

const fmt = (seconds) => {
  if (!seconds || isNaN(seconds)) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const remainder = Math.floor(seconds % 60);
  return `${minutes}:${String(remainder).padStart(2, '0')}`;
};

const streamUrl = (url) => {
  if (!url) return '';
  if (url.includes('dropbox.com')) {
    return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com').replace('?dl=1', '');
  }
  return url;
};

function Avatar({ src, name, size = 112 }) {
  const [err, setErr] = useState(false);
  const initial = name?.charAt(0).toUpperCase() || '?';
  return (
    <div className="vd-avatar-wrap" style={{ width: size, height: size }}>
      <div className="vd-avatar-ring" />
      <div className="vd-avatar">
        {src && !err ? (
          <img src={streamUrl(src)} alt={name} onError={() => setErr(true)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span className="vd-avatar-init">{initial}</span>
        )}
      </div>
    </div>
  );
}

function VotingDetails() {
  injectStyles();
  const { id } = useParams();
  const [competition, setCompetition] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [voteCounts, setVoteCounts] = useState({});
  const [loadingVotes, setLoadingVotes] = useState({});
  const [flashSuccess, setFlashSuccess] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [currentSong, setCurrentSong] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  const [voteError, setVoteError] = useState(false);
  const audioRef = useRef(null);

  const sortedParticipants = useMemo(
    () => [...participants].sort((a, b) => (voteCounts[b.id] || 0) - (voteCounts[a.id] || 0)),
    [participants, voteCounts]
  );

  useEffect(() => {
    let isCurrent = true;
    const fetchAll = async () => {
      try {
        setIsLoading(true);
        setLoadError(false);
        const [competitionResponse, participantsResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/competitions/${id}`),
          axios.get(`${process.env.REACT_APP_API_URL}/competitions/${id}/participants`),
        ]);
        if (!isCurrent) return;
        setCompetition(competitionResponse.data);
        setParticipants(participantsResponse.data);
        const voteResponses = await Promise.all(
          participantsResponse.data.map((participant) => axios.get(`${process.env.REACT_APP_API_URL}/votes/participant/${participant.id}`))
        );
        const counts = {};
        voteResponses.forEach((response, index) => { counts[participantsResponse.data[index].id] = response.data.length; });
        if (isCurrent) setVoteCounts(counts);
      } catch (error) {
        console.error(error);
        if (isCurrent) setLoadError(true);
      } finally {
        if (isCurrent) setIsLoading(false);
      }
    };
    fetchAll();
    return () => { isCurrent = false; };
  }, [id]);

  useEffect(() => () => { audioRef.current?.pause(); }, []);

  const handleVote = async (participantId) => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      toast.error('Please log in to vote');
      return;
    }
    setLoadingVotes((previous) => ({ ...previous, [participantId]: true }));
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/votes`, { userId, competitionId: id, participantId });
      setVoteError(false);
      setVoteCounts((previous) => ({ ...previous, [participantId]: (previous[participantId] || 0) + 1 }));
      setFlashSuccess((previous) => ({ ...previous, [participantId]: true }));
      setTimeout(() => setFlashSuccess((previous) => ({ ...previous, [participantId]: false })), 1800);
      toast.success('Vote submitted!');
    } catch (error) {
      setVoteError(true);
      if (error.response?.status === 403) toast.error('Insufficient vote balance.');
      else toast.error('Already voted or an error occurred.');
    } finally {
      setLoadingVotes((previous) => ({ ...previous, [participantId]: false }));
    }
  };

  const confirmVote = async () => {
    if (!selectedParticipant) return;
    const participantId = selectedParticipant.id;
    setSelectedParticipant(null);
    await handleVote(participantId);
  };

  const openPlayer = (participant) => {
    if (!participant.details.song) return;
    audioRef.current?.pause();
    setCurrentSong({ participant, artist: participant.details, song: participant.details.song });
    setShowPlayerModal(true);
    setIsPlaying(false);
    setCurrentTime(0);
    setDuration(0);
  };

  const closePlayer = () => {
    audioRef.current?.pause();
    setShowPlayerModal(false);
    setIsPlaying(false);
    setCurrentSong(null);
  };

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) audioRef.current.pause();
    else audioRef.current.play().catch(() => toast.error('Unable to play this preview.'));
  };

  const getInfo = (participant) => {
    const details = participant.details || {};
    if (participant.participantType === 'artist') return { name: details.name || 'Artist', img: details.artist_image_url };
    if (participant.participantType === 'coach') return { name: `${details.firstName || ''} ${details.lastName || ''}`.trim() || details.name || 'Coach', img: details.profilePicture };
    if (participant.participantType === 'club') return { name: details.name || 'Club', img: details.logo };
    if (participant.participantType === 'player' || participant.participantType === 'model') return { name: details.name || 'Participant', img: details.profileImageUrl };
    return { name: details.name || 'Participant', img: null };
  };

  const votingStatus = (campaign) => {
    const now = new Date();
    if (campaign.status === 'completed' || (campaign.endDate && new Date(campaign.endDate) <= now)) return 'Closed';
    if (campaign.startDate && new Date(campaign.startDate) > now) return 'Upcoming';
    return campaign.status === 'active' ? 'Active' : campaign.status || 'Unavailable';
  };
  const campaignStatus = competition ? votingStatus(competition) : '';
  const isVotingOpen = campaignStatus === 'Active';

  return (
    <VotingPageShell>
      <div className="vd-wrap">
        {isLoading ? (
          <div role="status" className="vd-loader">
            <div aria-hidden="true" className="vd-loader-ring" />
            <p>Loading campaign</p>
          </div>
        ) : (
          <>
            {loadError && <div role="alert" className="vd-error">We couldn't load this campaign or all nominee totals. Please try again later.</div>}
            {competition ? (
              <>
                <header className="border-b border-line bg-surface-900">
                  <div className="vd-hero mx-auto max-w-7xl">
                    <div className="vd-hero-eyebrow"><span /> Voting campaign <span /></div>
                    <h1>{competition.title}</h1>
                    {competition.description && <p>{competition.description}</p>}
                  </div>
                </header>
                <div className="vd-actions">
                  <Link to="/voting"><ArrowLeftIcon aria-hidden="true" className="h-4 w-4" /> All campaigns</Link>
                  <span className="inline-flex items-center gap-2 rounded-md border border-line bg-surface-850 px-3 py-1.5 text-xs font-medium text-gray-300">
                    <span className={`h-1.5 w-1.5 rounded-full ${campaignStatus === 'Active' ? 'bg-emerald-400' : 'bg-gray-500'}`} />
                    {campaignStatus}
                  </span>
                </div>
                {(competition.startDate || competition.endDate || competition.rules) && (
                  <div className="vd-rules">
                    {(competition.startDate || competition.endDate) && (
                      <>
                        <span className="font-semibold text-gray-200">Voting period</span>
                        {competition.startDate && <> · Starts {new Date(competition.startDate).toLocaleDateString()}</>}
                        {competition.endDate && <> · Ends {new Date(competition.endDate).toLocaleDateString()}</>}
                      </>
                    )}
                    {competition.rules && <p className="mt-2">{competition.rules}</p>}
                  </div>
                )}
                {voteError && <div role="alert" className="vd-error vote-error">Your vote wasn't recorded. Please review the notification and try again.</div>}
                <div className="mx-auto max-w-7xl px-5 pb-4 sm:px-8 lg:px-10">
                  <h2 className="inline-flex items-center gap-2 text-lg font-semibold text-white">
                    <TrophyIcon aria-hidden="true" className="h-5 w-5 text-accent-soft" /> Nominees
                  </h2>
                  <p className="mt-1 text-sm text-gray-400">Choose a nominee to show your support.</p>
                </div>
                {sortedParticipants.length > 0 ? (
                  <div className="vd-grid">
                    {sortedParticipants.map((participant, index) => {
                      const { name, img } = getInfo(participant);
                      const song = participant.details?.song;
                      const hasSong = participant.participantType === 'artist' && song?.audio_url;
                      const votes = voteCounts[participant.id] || 0;
                      const isVoting = Boolean(loadingVotes[participant.id]);
                      const didVote = Boolean(flashSuccess[participant.id]);

                      return (
                        <article key={participant.id} className="vd-card">
                          <div className={`vd-rank ${index === 0 ? 'vd-rank-1' : ''}`}>#{index + 1}</div>
                          <Avatar src={img} name={name} />
                          <h3 className="vd-name">{name}</h3>

                          {participant.details?.country && (
                            <div className="vd-meta">
                              <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              {participant.details.country}
                            </div>
                          )}

                          {hasSong ? (
                            <div className="vd-song">
                              <div className="vd-song-info">
                                <div className="vd-song-title">{song.title}</div>
                                <div className="vd-song-sub">
                                  {song.genre || 'Unknown'}{song.release_year ? ` · ${song.release_year}` : ''} · {fmt(song.duration_seconds)}
                                </div>
                              </div>
                              <button type="button" aria-label={`Play ${song.title}`} className="vd-play-btn" onClick={() => openPlayer(participant)}>
                                <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                              </button>
                            </div>
                          ) : (
                            <div className="vd-no-song">No track available</div>
                          )}

                          <div className="vd-vote-row">
                            <div className="vd-count">
                              <span className="vd-count-num" aria-label={`${votes} votes`}>{votes}</span>
                              <span className="vd-count-label">votes</span>
                            </div>
                            <div className="vd-divider" />
                            <button
                              type="button"
                              className={`vd-vote-btn${didVote ? ' success' : ''}`}
                              onClick={() => setSelectedParticipant(participant)}
                              disabled={isVoting || !isVotingOpen}
                              aria-label={`Vote for ${name}`}
                            >
                              {isVoting ? <><span className="spin" aria-hidden="true" /> Voting…</> : didVote ? 'Voted!' : isVotingOpen ? 'Vote Now' : `Voting ${campaignStatus.toLowerCase()}`}
                            </button>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                ) : (
                  <div className="vd-empty">
                    <SparklesIcon aria-hidden="true" className="mx-auto mb-3 h-8 w-8 text-gray-500" />
                    <h3 className="text-lg font-semibold text-white">No nominees available</h3>
                    <p className="mt-2 text-sm text-gray-400">There are no nominees listed for this campaign yet.</p>
                  </div>
                )}
              </>
            ) : (
              <div role="alert" className="vd-empty">
                <h2 className="text-lg font-semibold text-white">Campaign not found</h2>
                <p className="mt-2">We couldn't find this voting campaign.</p>
                <Link className="mt-4 inline-flex items-center gap-2 text-sm text-accent-soft" to="/voting">
                  <ArrowLeftIcon aria-hidden="true" className="h-4 w-4" /> Back to campaigns
                </Link>
              </div>
            )}
          </>
        )}

        {selectedParticipant && (
          <div className="vd-overlay" role="presentation" onClick={(event) => event.target === event.currentTarget && setSelectedParticipant(null)}>
            <section className="vd-player" role="dialog" aria-modal="true" aria-labelledby="vote-confirm-title" onKeyDown={(event) => { if (event.key === 'Escape') setSelectedParticipant(null); }}>
              <h2 id="vote-confirm-title" className="text-xl font-bold text-white">Confirm your vote</h2>
              <p className="mt-3 text-sm leading-6 text-gray-300">
                Submit your vote for <span className="font-semibold text-white">{getInfo(selectedParticipant).name}</span> in {competition?.title}?
              </p>
              <p className="mt-2 text-xs text-gray-500">Your vote will be submitted to the campaign and may not be changed.</p>
              <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                <button type="button" className="btn-secondary" onClick={() => setSelectedParticipant(null)}>Cancel</button>
                <button type="button" className="btn-primary" onClick={confirmVote}>Submit vote</button>
              </div>
            </section>
          </div>
        )}

        {showPlayerModal && currentSong && (
          <div className="vd-overlay" role="presentation" onClick={(event) => event.target === event.currentTarget && closePlayer()}>
            <div className="vd-player" role="dialog" aria-modal="true" aria-label={`${currentSong.song.title} audio player`}>
              <button type="button" aria-label="Close music player" className="vd-player-close" onClick={closePlayer}>
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <audio
                ref={audioRef}
                src={streamUrl(currentSong.song.audio_url)}
                preload="metadata"
                onTimeUpdate={() => setCurrentTime(audioRef.current?.currentTime || 0)}
                onLoadedMetadata={() => setDuration(audioRef.current?.duration || 0)}
                onEnded={() => { setIsPlaying(false); setCurrentTime(0); }}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onError={() => toast.error('Unable to load this preview.')}
                controlsList="nodownload"
              />

              <div className="vd-cover-wrap">
                {currentSong.song.cover_image_url ? (
                  <img src={streamUrl(currentSong.song.cover_image_url)} alt={currentSong.song.title} onError={(event) => { event.currentTarget.style.display = 'none'; }} />
                ) : (
                  <span className="vd-cover-init">{currentSong.song.title?.charAt(0).toUpperCase() || '♪'}</span>
                )}
              </div>

              <div className="vd-player-info">
                <div className="vd-player-title">{currentSong.song.title}</div>
                <div className="vd-player-artist">{currentSong.artist.name}</div>
                <div className="vd-player-genre">
                  {currentSong.song.genre || 'Unknown genre'}
                  {currentSong.song.release_year ? ` · ${currentSong.song.release_year}` : ''}
                </div>
              </div>

              <div className="vd-progress-wrap">
                <input type="range" aria-label="Playback position" className="vd-progress" min="0" max={duration || 0} value={currentTime}
                  onChange={(event) => {
                    const nextTime = parseFloat(event.target.value);
                    if (audioRef.current) audioRef.current.currentTime = nextTime;
                    setCurrentTime(nextTime);
                  }}
                  style={{ background: `linear-gradient(to right, #d81f2a ${(currentTime / (duration || 1)) * 100}%, #26262a 0)` }}
                />
                <div className="vd-time-row"><span>{fmt(currentTime)}</span><span>{fmt(duration)}</span></div>
              </div>

              <div className="vd-controls">
                <button type="button" className="vd-pp-btn" aria-label={isPlaying ? 'Pause preview' : 'Play preview'} onClick={togglePlay}>
                  {isPlaying
                    ? <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6" /></svg>
                    : <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" style={{ marginLeft: 2 }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /></svg>
                  }
                </button>
              </div>

              <div className="vd-vol-row">
                <svg className="vd-vol-icon" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                </svg>
                <input type="range" aria-label="Volume" className="vd-vol-slider" min="0" max="1" step="0.01" value={volume}
                  onChange={(event) => {
                    const nextVolume = parseFloat(event.target.value);
                    setVolume(nextVolume);
                    if (audioRef.current) audioRef.current.volume = nextVolume;
                  }}
                  style={{ background: `linear-gradient(to right, #9ca3af ${volume * 100}%, #26262a 0)` }}
                />
              </div>

              <div className="vd-secure">
                <svg width="10" height="10" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Secure streaming · Download disabled
              </div>
            </div>
          </div>
        )}
      </div>
    </VotingPageShell>
  );
}

export default VotingDetails;
